import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent extends BaseComponent implements OnInit,OnChanges {

  @Input() itemValue: number = 60;

  @Input() pieChartType = 0;

  chartBgColor = '#fff';

  chartLabelColor = '#007bb9';

  chartTitle = '';

  @ViewChild('pie') pie: ElementRef;

  workDonePerc = '';

  deg = '';

  applyColor = false;

  backgroundImage = '';

  chartBgColors = {
    all: '#007bb9',
    unattempted: '#d5d5d5',
    inprogress: '#f7a500',
    completed: '#12a539'
  };

  chartLabelColors = {
    all: '#007bb9',
    unattempted: '#606060',
    inprogress: '#996600',
    completed: '#0e7c2b'
  };

  constructor(ele: ElementRef) {
    super(ele);
  }

  ngOnInit() {
    this.setPieChartDesign();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setPieChartDesign();
  }

  calculateDeg() {
    return (this.itemValue) * 360;
  }

  calculatePieDegree() {
    const baseDeg = 180;
    let calculatedDeg = this.calculateDeg();
    if (calculatedDeg > baseDeg) {
      this.applyColor = true;
      calculatedDeg -= baseDeg;
    }
    return calculatedDeg;
  }

  calculatePiePerc(deg) {
    return (deg / 360) * 100;
  }

  checkForDecimalPoint(val) {
    if (val % 1 !== 0) {
      val = val.toPrecision(2);
    }
    return val;
  }

  setPieChartDesign() {
    switch (this.pieChartType) {
      case PieChartType.ALL:
        this.setChartValues(this.chartBgColors.all, this.chartLabelColors.all);
        break;
      case PieChartType.INPROGRESS:
        this.setChartValues(this.chartBgColors.inprogress, this.chartLabelColors.inprogress);
        this.chartTitle = 'Inprogress';
        break;
      case PieChartType.UNATTEMPTED:
        this.setChartValues(this.chartBgColors.unattempted, this.chartLabelColors.unattempted);
        this.chartTitle = 'Unattempted';
        break;
      case PieChartType.COMPLETED:
        this.setChartValues(this.chartBgColors.completed, this.chartLabelColors.completed);
        this.chartTitle = 'Completed';
        break;
    }
  }

  setChartValues(bgColor, labelColor) {
    this.chartBgColor = bgColor;
    this.chartLabelColor = labelColor;
    this.backgroundImage = 'linear-gradient(to right, transparent 50%, ' + this.chartBgColor + ' 0)';
    let rotationDeg = this.calculatePieDegree();
    if (this.pieChartType === PieChartType.UNATTEMPTED) {
      this.applyColor = true;
      rotationDeg = 180;
    }
    this.deg = 'rotate(' + rotationDeg + 'deg)';
    if(this.itemValue <= 0.5 && this.itemValue > 0) {
      this.applyColor = false;
    }
    this.workDonePerc = this.checkForDecimalPoint(this.calculatePiePerc(this.calculateDeg())) + '%';

  }

}

export enum PieChartType {
  ALL = 0,
  INPROGRESS = 1,
  UNATTEMPTED = 2,
  COMPLETED = 3
}




// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/pie-chart/pie-chart.component.ts